var _path, _line, _line2, _circle, _circle2, _path2, _path3, _path4, _path5, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaloriesCalculator = function SvgCaloriesCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 120C94.5848 120 121 94.2564 121 62.5C121 30.7436 94.5848 5 62 5C29.4152 5 3 30.7436 3 62.5C3 94.2564 29.4152 120 62 120Z",
    fill: "#F6F9F7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 111.99,
    y1: 14,
    x2: 111.99,
    y2: 26.607,
    stroke: "#FF5F5A",
    strokeWidth: 3.15175
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 105.5,
    y1: 20.3616,
    x2: 118.107,
    y2: 20.3616,
    stroke: "#FF5F5A",
    strokeWidth: 3.15175
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.3242,
    cy: 64.582,
    r: 28.7083,
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.15366
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.3246,
    cy: 64.5805,
    r: 20.7214,
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 1.15366
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.319 36.6279L62.3574 38.8465C76.5563 40.9763 88.2089 54.2286 90.2795 60.5885C87.1735 42.8399 72.6789 37.2195 66.319 36.6279Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3536 92.6942V35.2554C97.3536 33.7826 96.1262 33.1689 95.5126 33.0462C94.6534 32.8007 92.3461 33.4144 89.9896 37.8327C87.044 43.3557 86.3076 50.7197 86.3076 55.8744C86.3076 61.0292 88.885 63.6066 90.726 63.9748C92.1988 64.2693 92.3215 65.8158 92.1988 66.5522L91.8306 76.8617V90.485C91.8306 91.5896 92.1988 94.9034 94.7762 94.9034C96.8381 94.9034 97.3536 93.4306 97.3536 92.6942Z",
    fill: "#BBBBBB",
    stroke: "#1B382F",
    strokeWidth: 1.22541
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1514 85.5385C27.0895 93.2336 30.5015 95.1269 32.4652 95.1116C36.147 95.1116 37.6201 91.0614 36.1473 85.5385C34.9691 81.1201 34.4291 66.2695 34.3063 59.3964C34.4291 58.5373 34.7482 56.6718 35.0427 56.0827C35.4109 55.3463 39.4611 53.1371 39.8293 51.2961C40.1239 49.8233 40.1975 47.4914 40.1975 46.5095L39.8293 33.9908C39.8293 33.7453 39.6084 33.2544 38.7247 33.2544C37.841 33.2544 37.6201 33.7453 37.6201 33.9908V48.3505C37.6201 48.9396 37.1292 49.0869 36.8837 49.0869H36.5155C35.9264 49.0869 35.7791 48.596 35.7791 48.3505V33.9908C35.7791 33.7453 35.5582 33.2544 34.6745 33.2544C33.7909 33.2544 33.5699 33.7453 33.5699 33.9908V48.3505C33.5699 48.9396 33.079 49.0869 32.8336 49.0869H32.4654C31.8762 49.0869 31.729 48.596 31.729 48.3505V33.9908C31.729 33.7453 31.508 33.2544 30.6243 33.2544C29.7405 33.2544 29.5197 33.7453 29.5197 33.9908V48.7187C29.5197 49.0133 29.0288 49.0869 28.7834 49.0869H28.4152C27.8261 49.0869 27.6788 48.596 27.6788 48.3505V33.9908C27.6788 33.7453 27.4579 33.2544 26.5742 33.2544C25.6905 33.2544 25.4695 33.7453 25.4695 33.9908C25.224 38.2864 24.8068 47.5405 25.1013 50.1915C25.4695 53.5053 28.4151 54.9781 29.5197 56.0827C30.4034 56.9663 30.6243 58.66 30.6243 59.3964C30.9925 64.9041 31.2133 77.8433 29.1514 85.5385Z",
    fill: "#BBBBBB",
    stroke: "#1B382F",
    strokeWidth: 1.22541
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 57.5C117.5 70.0443 113.253 82.2397 105.415 92.1945C97.5769 102.15 86.5855 109.308 74.144 112.557",
    stroke: "#ABB8B3",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.35355,
    y1: 24.7969,
    x2: 3.35355,
    y2: 31.3127,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 28.0879,
    x2: 6.51587,
    y2: 28.0879,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 70.3848,
    y1: 13,
    x2: 70.3848,
    y2: 19.5159,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 67.0312,
    y1: 16.291,
    x2: 73.5471,
    y2: 16.291,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })));
};
export default SvgCaloriesCalculator;